import { FC, MouseEvent, useCallback, useEffect, useRef } from 'react';
import { useDropDown } from '../../lib';
import { DropDownStyled } from './drop-down.styled';
import { IDropDownProps } from './drop-down.types';

export const DropDown: FC<IDropDownProps> = ({
  offset = 0,
  placement = 'bottom',
  isOverToggler,
  shouldShift = true,
  strategy,
  middlewares,
  shouldFlip,
  shouldAutoPlacement,
  useParentWidth = true,
  content,
  children,
  positionRef,
  disabled,
}) => {
  const componentRef = useRef(null);

  const { refs, floatingStyles, isOpen, toggleDrop, closeDrop } = useDropDown({
    placement,
    offset,
    shouldAutoPlacement,
    middlewares,
    useParentWidth,
    componentRef,
    strategy,
    isOverToggler,
    shouldShift,
    shouldFlip,
  });

  const togglerClickHandler = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();

      if (!disabled) {
        toggleDrop();
      }
    },
    [disabled, toggleDrop],
  );

  const clickOutsideHandler = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      closeDrop();
    },
    [closeDrop],
  );

  useEffect(() => {
    if (positionRef && positionRef.current) {
      refs.setPositionReference({
        getBoundingClientRect() {
          const rect = positionRef.current?.getBoundingClientRect();
          return {
            width: rect?.width ?? 0,
            height: rect?.height ?? 0,
            x: rect?.x ?? 0,
            y: rect?.y ?? 0,
            top: rect?.top ?? 0,
            right: rect?.right ?? 0,
            bottom: rect?.bottom ?? 0,
            left: rect?.left ?? 0,
          };
        },
      });
    }
  }, [positionRef, refs]);

  return (
    <DropDownStyled tabIndex={0} ref={componentRef}>
      <div
        className="toggler"
        ref={refs.setReference}
        onClick={togglerClickHandler}
      >
        {children}
      </div>
      {isOpen && (
        <>
          <div
            className="content"
            ref={refs.setFloating}
            style={floatingStyles}
            onClick={e => e.stopPropagation()}
          >
            {content}
          </div>
          <div className="drop-shadow" onClick={clickOutsideHandler}></div>
        </>
      )}
    </DropDownStyled>
  );
};
